import Card from "components/card";
import DonutChart from "components/charts/DonutChart";
import Loader from "components/loader";
import useStats from "hooks/useStats";
import { useEffect, useMemo } from "react";
import { DASHBOARD_COLORS } from "utils/dashboardColors";

const COLOR_CYCLE = [
  DASHBOARD_COLORS.varios,
  DASHBOARD_COLORS.instituciones,
  DASHBOARD_COLORS.postulantes,
  DASHBOARD_COLORS.otros,
  DASHBOARD_COLORS.base,
  DASHBOARD_COLORS.gold,
];

const PublicacionesEstadoChart = () => {
  const { isLoading, response, fetchData } = useStats("publicaciones-por-estado");

  useEffect(() => {
    fetchData(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rows = useMemo(() => (Array.isArray(response) ? response : []), [response]);

  const chartOptions = useMemo(
    () => ({
      chart: { type: "donut" },
      labels: rows.map((item) => item.estado),
      colors: rows.map((_, idx) => COLOR_CYCLE[idx % COLOR_CYCLE.length]),
      legend: { show: true, position: "bottom" },
      dataLabels: { enabled: true },
      tooltip: { theme: "dark" },
    }),
    [rows]
  );

  return (
    <Card extra="w-full h-[460px] px-6 py-4">
      <div className="text-xl font-bold text-navy-700 dark:text-white mb-2">
        Estado de publicaciones
      </div>

      <div className="mt-2 flex h-[380px] w-full items-center justify-center">
        {isLoading ? (
          <Loader />
        ) : rows.length === 0 ? (
          <p className="text-sm text-gray-600 dark:text-gray-400">No hay datos disponibles</p>
        ) : (
          <DonutChart options={chartOptions} series={rows.map((item) => Number(item.count || 0))} />
        )}
      </div>
    </Card>
  );
};

export default PublicacionesEstadoChart;
